// function for accordion

function toggleDetail(header) {
  const content = header.nextElementSibling;
  const arrow = header.querySelector("span");
  header.setAttribute('aria-expanded', 'true')

  // Close all other details
  document.querySelectorAll(".detail-content").forEach((detail) => {
    if (detail !== content) {
      detail.classList.remove("active");
      detail.previousElementSibling.setAttribute('aria-expanded', 'false')
    }
  });

  document.querySelectorAll(".detail-header span").forEach((span) => {
    if (span !== arrow) {
      span.style.transform = "rotate(0deg)";
    }
  });

  // Toggle current detail
  content.classList.toggle("active");
  arrow.style.transform = content.classList.contains("active")
    ? "rotate(180deg)"
    : "rotate(0deg)";
  header.setAttribute('aria-expanded', content.classList.contains("active") ? "true": "false");
}

document.addEventListener("DOMContentLoaded", () => {
  const imageScroller = document.querySelector(".product-image");
  const dotsContainer = document.querySelector(".image-dots");
  const dots = dotsContainer.querySelectorAll(".dot");
  const images = imageScroller.querySelectorAll(".image-container");

  // Function to scroll to an image when a dot is clicked
  dotsContainer.addEventListener("click", (e) => {
    if (!e.target.matches(".dot")) return;

    const index = e.target.dataset.index;
    const targetImage = imageScroller.querySelector(
      `.image-container[data-index="${index}"]`
    );
    if (targetImage) {
      targetImage.scrollIntoView({
        behavior: "smooth",
        block: "nearest",
        inline: "start",
      });
    }
  });

  // Use Intersection Observer to update active dot on scroll
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const index = entry.target.dataset.index;

          // Remove active class from all dots
          dots.forEach((dot) => dot.classList.remove("active"));

          // Add active class to the corresponding dot
          const activeDot = dotsContainer.querySelector(
            `.dot[data-index="${index}"]`
          );
          if (activeDot) {
            activeDot.classList.add("active");
          }
        }
      });
    },
    { root: imageScroller, threshold: 0.5 }
  );

  // Observe each image
  images.forEach((image) => observer.observe(image));

  const productUrl = document
    .querySelector(".optionValueSelectors")
    .getAttribute("data-product-url");
  // console.log(productUrl);

  let quantity = 1;

  function changeQuantity(change) {
    quantity = Math.max(1, quantity + change);
    document.getElementById("product-quantity").value = quantity;
  }

  document
    .getElementById("product-qty-decrement")
    .addEventListener("click", () => changeQuantity(-1));
  document
    .getElementById("product-qty-increment")
    .addEventListener("click", () => changeQuantity(1));
  const addToCartBtn = document.querySelector(".add-to-cart");

  // Funtion to get matchedVariant
  function getMatchedVariant() {
    const selectedOptions = Array.from(
      document.querySelectorAll(".size-dropdown")
    ).map((select) => select.value);

    const matchedVariant = product.variants.find((variant) => {
      return selectedOptions.every((optionValue, index) => {
        return variant.options[index] === optionValue;
      });
    });

    return matchedVariant;
  }

  // function to check availablity of product

  function checkAvailablity() {
    const matched = getMatchedVariant();
    // console.log(matched);

    addToCartBtn.textContent = matched.available ? "Add to cart" : "sold out";
    addToCartBtn.classList.toggle("not-available", !matched.available);
    if (!matched.available) {
      addToCartBtn.disabled = true;
      addToCartBtn.style.cursor = "not-allowed";
      addToCartBtn.style.pointerEvents = "none";
    }
  }

  // Funtion to update price
  function updatePrice(newPriceInCents) {
    const priceElement = document.querySelector(".price");
    if (!priceElement) return;
    priceElement.textContent = newPriceInCents;
  }

  // Funtion to add to cart
  async function addToCart(e) {
    e.preventDefault();
    // console.log("add to cart button clicked");
    const errorElement = document.querySelector(".product-error");

    const matchedVariant = getMatchedVariant();

    const formData = {
      items: [
        {
          id: matchedVariant.id,
          quantity: quantity,
        },
      ],
      sections: "cart-drawer,header",
    };

    // console.log(formData);

    try {
      addToCartBtn.disabled = true;
      addToCartBtn.style.cursor = "progress";
      addToCartBtn.textContent = "Loading...";
      const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify(formData),
      });

      const data = await response.json();

      if (!response.ok) {
        if (response.status === 422) {
          errorElement.style.display = "block";
          errorElement.textContent = data.description;
          updateCartDrawer();
          openCart();
        }
        throw new Error(data);
      }
      updateCartDrawer();
      updateCartCount(data.sections.header);
      openCart();
    } catch (error) {
      console.log(error);
      addToCartBtn.textContent = "Out of Stock";
    } finally {
      addToCartBtn.textContent = "Add to Cart";
      addToCartBtn.disabled = false;
      addToCartBtn.style.cursor = "pointer";
    }
  }

  // Funtion on variantChange
  function onVariantChange(event) {
    // Find parent container
    const optionValueSelectors = event.target.closest(".optionValueSelectors");
    const sectionId = optionValueSelectors.dataset.sectionId;
    const errorElement = document.querySelector(".product-error");
    errorElement.style.display = "none";

    // Get selected option values from ALL dropdowns
    const selectedOptionValues = Array.from(
      optionValueSelectors.querySelectorAll("select")
    )
      .map((selectEl) => {
        const selectedOption = selectEl.options[selectEl.selectedIndex];
        return selectedOption.dataset.optionValueId;
      })
      .filter(Boolean);

    // Format query param
    const params =
      selectedOptionValues.length > 0
        ? `&option_values=${selectedOptionValues.join(",")}`
        : "";

    addToCartBtn.disabled = true;
    addToCartBtn.style.cursor = "not-allowed";
    addToCartBtn.style.opacity = 0.5;

    // Fetch updated product section
    fetch(`${window.location.href}?section_id=${sectionId}${params}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, "text/html");
        optionValueSelectors.innerHTML = html.querySelector(
          ".optionValueSelectors"
        ).innerHTML;
        
        // Keep focus on the changed select
        reconcileSelections(optionValueSelectors, event.target.id)
        // document.querySelector(`#${event.target.id}`).focus();

        // After re-rendering the selectors, find the matching variant
        const matchedVariant = getMatchedVariant();
        if (matchedVariant) {
          updatePrice(Shopify.formatMoney(matchedVariant.price));
        }
        

        if (matchedVariant.available) {
          addToCartBtn.disabled = false;
          addToCartBtn.style.cursor = "pointer";
          addToCartBtn.style.opacity = 1;
        } else {
          addToCartBtn.disabled = true;
          addToCartBtn.style.cursor = "not-allowed";
          addToCartBtn.style.opacity = 0.5;
        }
      });
  }

  // Use event delegation on a static parent element
  const purchaseOptionsContainer = document.querySelector(".purchase-options");
  if (purchaseOptionsContainer) {
    purchaseOptionsContainer.addEventListener("change", (event) => {
      if (event.target.matches(".size-dropdown")) {
        onVariantChange(event);
      }
    });
  }

  function updateEventListeners() {
    // console.log("Added");
    addToCartBtn.addEventListener("click", addToCart);
  }


  function reconcileSelections(optionRootEl, changedSelectId) {
    const selects = Array.from(optionRootEl.querySelectorAll("select"));

    let focusEl = null;

    selects.forEach((selectEl) => {
      const currentOption = selectEl.options[selectEl.selectedIndex];

      const isCurrentValid =
        currentOption &&
        !currentOption.disabled &&
        currentOption.dataset.optionValueId;

      if (!isCurrentValid) {
        // Pick first available option (not disabled) with a valid data-option-value-id
        const firstAvailableIndex = Array.from(selectEl.options).findIndex(
          (opt) => !opt.disabled && !!opt.dataset.optionValueId
        );

        if (firstAvailableIndex >= 0) {
          selectEl.selectedIndex = firstAvailableIndex;

          // Prefer focusing the select the user changed; otherwise focus this one
          if (selectEl.id === changedSelectId) {
            focusEl = selectEl;
          } else if (!focusEl) {
            focusEl = selectEl;
          }
        } else {
          // Edge case: no available options in this select
          console.warn(
            `No available options for select#${selectEl.id || "(no id)"}`
          );
        }
      } else {
        // Current selection is valid; maintain focus priority on the changed select
        if (selectEl.id === changedSelectId && !focusEl) {
          focusEl = selectEl;
        }
      }
    });

    // Apply focus after reconciliation
    if (focusEl) {
      focusEl.focus();
    }
  }

  updateEventListeners();
  checkAvailablity();
});
